import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import style from '../highlightStyle';

const Highlight = ({ code, children, language }) => {
  return (
    <SyntaxHighlighter language={`${language || 'javascript'}`} style={style} className="highlight">
      {code || children}
    </SyntaxHighlighter>
  );
};

export default Highlight;
